import React from 'react';
import { useTranslation } from 'react-i18next';
import {
    Box,
    Flex,
    Input,
    InputGroup,
    InputLeftElement,
    Switch,
    Text
} from '@chakra-ui/react';
import { SearchIcon } from '@chakra-ui/icons';

export default function UserFilter(props: {
    userFilter: Record<string, any>;
    setUserFilter: Function;
}): React.ReactElement {
    const { t } = useTranslation();
    const [swithcIsOn, setSwitchIsOn] = React.useState(false);

    return (
        <Box>
            <InputGroup>
                <InputLeftElement
                    pointerEvents='none'
                    children={<SearchIcon color='gray.300' />}
                />
                <Input
                    type='text'
                    placeholder='Buscar por nombre'
                    value={props.userFilter?.identifier || ''}
                    onChange={(e) =>
                        props.setUserFilter({
                            ...props.userFilter,
                            identifier: e.target.value
                        })
                    }
                />
            </InputGroup>

            <Flex my='4' align={'center'}>
                <Text mr='4'>{t('users.verified', 'Verificado')}</Text>
                <Switch
                    isChecked={props.userFilter.isVerified}
                    value={props.userFilter.isVerified ? 1 : 0}
                    onChange={(e: any) => {
                        props.setUserFilter({
                            ...props.userFilter,
                            isVerified: e.target.checked
                        });
                    }}
                />
            </Flex>
        </Box>
    );
}
